<template>
    <div>
        <!-- Admin dashboard preview -->
        <div id="features" class="container pb-5 mb-md-5 mt-100 mt-60 tw-scroll-mt-8">
            <div class="row">
                <div class="col-lg-7">
                    <div class="saas-feature-shape-left position-relative tw-w-full lg:tw-w-[550px] xl:tw-w-[620px] tw-h-[400px] md:tw-h-[550px] lg:tw-h-[440px] xl:tw-h-[500px]">
                        <img
                            src="../../assets/img/admin-dashboard-dark.jpg"
                            class="img-fluid mx-auto d-block tw-rounded-[8px] shadow position-absolute tw-top-0 tw-left-0 tw-transition tw-duration-500"
                            :alt="`Docwriter - Screenshot preview of admin dashboard (${appName})`"
                            title="Preview"
                        />

                        <img
                            src="../../assets/img/admin-dashboard-2.jpg"
                            class="img-fluid mx-auto d-block tw-rounded-[6px] shadow position-absolute tw-top-0 tw-left-0 tw-transition hover:tw-opacity-0 tw-duration-500"
                            :alt="`Docwriter - Screenshot preview of admin dashboard (${appName})`"
                            title="Preview"
                        />
                    </div>
                </div>

                <div class="col-lg-5 mt-4 pt-2 mt-lg-0 pt-lg-0">
                    <div class="section-title ml-lg-4">
                        <h2 class="title mb-3">
                            Create content <span class="text-primary">rapidly</span>
                        </h2>

                        <p class="para-desc text-muted">
                            Meet our administration panel featuring rich content
                            editing using Markdown with instant preview and WYSIWYG mode.
                            The built-in Media Manager will allow you to upload and organize
                            the media files the way you want.
                        </p>

                        <a @click.prevent="showFeatures.contentCreation = !showFeatures.contentCreation" href="#">
                            <h5 class="text-primary">
                                Show features
                                <i
                                    class="mdi tw-relative tw-top-[1px]"
                                    :class="{ 'mdi-plus-box-outline': !showFeatures.contentCreation, 'mdi-minus-box-outline': showFeatures.contentCreation }">
                                </i>
                            </h5>
                        </a>

                        <transition name="fade">
                            <ul
                                v-if="showFeatures.contentCreation"
                                class="list-unstyled pt-3 border-top">

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Multi-language support
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Drag & Drop Content tree organizer
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Multiple Project support
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Project team management
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Custom domain support for Projects
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Multiple Documentation per Project support
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Design customization per Documentation
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Optional user/password protection for Documentations
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Optional Google analytics tracking
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Markdown with instant preview / WYSIWYG editor
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Preserving of unsaved content changes
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        A vast set of Markdown plugins for rich content creation
                                    </span>
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

        <!-- Viewer preview -->
        <div class="container">
            <div class="row">
                <div class="col-lg-5 order-2 order-lg-1 tw-pt-14 mt-lg-0 pt-lg-0">
                    <div class="section-title mr-lg-4">
                        <h2 class="title mb-3">Read content <span class="text-primary">easily</span></h2>

                        <p class="para-desc text-muted">
                            Meet our simple, yet powerful content reader.
                        </p>

                        <a @click.prevent="showFeatures.contentReading = !showFeatures.contentReading" href="#">
                            <h5 class="text-primary">
                                Show features
                                <i
                                    class="mdi tw-relative tw-top-[1px]"
                                    :class="{ 'mdi-plus-box-outline': !showFeatures.contentReading, 'mdi-minus-box-outline': showFeatures.contentReading }">
                                </i>
                            </h5>
                        </a>

                        <transition name="fade">
                            <ul
                                v-if="showFeatures.contentReading"
                                class="list-unstyled pt-3 border-top">

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Mobile friendly
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        The content reader will blend with your brand design nicely, thanks to the design customization features
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        The navigation within the content is easy and fast thanks to the navigable content menu and auto-generated tables of contents within each page
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        All headers in the content have auto-generated deep links allowing you to link specific sections from where it is needed
                                    </span>
                                </li>

                                <li class="h6 text-muted mb-0 tw-flex">
                                    <span class="text-primary h5 mr-2">
                                        <i class="uil uil-check-circle align-middle"></i>
                                    </span>

                                    <span class="tw-mb-2 tw-mt-[2px]">
                                        Previous and Next buttons provide quick navigation forward and backward
                                    </span>
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>

                <div class="col-lg-7 order-1 order-lg-2">
                    <div class="saas-feature-shape-right position-relative">
                        <img
                            src="../../assets/img/phoxio-preview.jpg"
                            class="img-fluid mx-auto d-block rounded shadow"
                            :alt="`Docwriter - Documentation content screenshot preview (${appName})`"
                            title="Preview"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ShieldIcon, LayersIcon } from 'vue-feather-icons';
    import { appName } from '@/store';

    export default {
        components: {
            LayersIcon,
            ShieldIcon,
        },

        data() {
            return {
                appName: appName,

                showFeatures: {
                    contentCreation: false,
                    contentReading: false,
                }
            }
        }
    }
</script>
